import React from 'react';
import {FormattedDate, FormattedPrice} from 'clorian-frontend-components';
import ReturnTicketInfo from "../../components/ReturnTicketInfo";
import Cookie from "js-cookie";


export const getTableColumns = (payoutValidation,forceValidation, currency) => {

  const rolesFromSessionStorage = JSON.parse(sessionStorage.getItem('roles'));
  const canForceValidation = rolesFromSessionStorage.includes('ROLE_AFFILIATE_CLIENT');
  const locale = Cookie.get('locale') || 'en';

  return (
    [
      {
        name: "returnId",
        label: "Return Id",
        options: {
          sort: true,
        }
      },
      {
        name: "purchaseId",
        options: {
          display: false,
        }
      },
      {
        name: "creationDate",
        label: "Creation Date",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => <FormattedDate value={value}/>
        }
      },
      ...(payoutValidation ? generateStatus() : []),
      {
        name: "returnValue",
        label: "Return Value",
        options: {
          filter: true,
          sort: false,
          customBodyRender: (value) => {
            return <FormattedPrice value={value} currency={currency} locale={locale}/>
          }
        }
      },
      ...(canForceValidation ? generateForceValidationButton(forceValidation) : [])
    ]);
};

export const getTableOptions = (dispatch) => {

  const tableOptions = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'scrollMaxHeight',
    selectableRows: 'none',
    expandableRows: true,
    //expandableRowsOnClick: true,
    isRowExpandable: (dataIndex, expandedRows) => {
      // Prevent expand/collapse of any row if there are 2 rows expanded already
      if (expandedRows.data.length > 2 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0) return false;
        return true;
    },
    renderExpandableRow: (rowData, rowMeta, x) => {

      const colspan = rowData.length - 1;
      const purchaseId = rowData[1];
      return ( <ReturnTicketInfo purchaseId={purchaseId} colspan={colspan}/>)
    }
  };

  return tableOptions;
};


function generateStatus() {
  return [
    {
      name: "valid",
      label: "Status",
      options: {
        sort: true,
        customBodyRender: (value) => {
          const className = value ? "label label-success" : "label label-warning";
          const text = value ? "Valid" : "Invalid";
          return <span className={className}>{text}</span>
        }
      }
    }
  ];
}

function generateForceValidationButton(forceValidation) {

  return [
    {
      name: "returnId",
      label: " ",
      options: {
        sort: true,
        customBodyRender: (value, rowData) => {

          if(rowData && !rowData.rowData[3])
            return <button className="btn btn-default btn-xs linkButtons" onClick={() => forceValidation(value)}>Force Validation</button>
        }
      }
    }
  ];
}

